import { createContext } from "react";

export const ExploreContext = createContext();
